import { useEffect } from "react";

function hexToRgb(hex: string) {
  const sanitized = hex.replace("#", "");
  if (!/^[0-9A-Fa-f]{6}$/.test(sanitized)) return null;

  const bigint = parseInt(sanitized, 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
}

export function WidgetThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const primary = params.get("primary");
    const background = params.get("background");

    const root = document.documentElement;

    if (primary) {
      const rgb = hexToRgb(primary);
      if (rgb) {
        root.style.setProperty(
          "--sl-primary-rgb",
          `${rgb.r}, ${rgb.g}, ${rgb.b}`
        );
      }
    }

    if (background) {
      root.style.setProperty("--widget-bg", background);
    }
  }, []);

  return <>{children}</>;
}
